import { render, staticRenderFns } from "./discussCategory.vue?vue&type=template&id=3c02736c"
import script from "./discussCategory.vue?vue&type=script&lang=js"
export * from "./discussCategory.vue?vue&type=script&lang=js"
import style0 from "./discussCategory.vue?vue&type=style&index=0&id=3c02736c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports